/* eslint-disable */
import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OnBoard from './onBoard';
import withAdminLayout from '../../layout/withAdminLayout';
import { AppRoutes } from '../routes';
import Navigate from '../navigate';
import CancelledJobs from '../../container/jobs/CancelledJobs';
import Logistics from '../../container/logistics';
import SpareJobs from '../../container/jobs/SpareJobs';
import LogisticsJob from '../../container/jobs/LogisticJobs';

const NotFound = lazy(() => import('../../container/pages/404'));

const Dashboard = lazy(() => import('../../container/dashboard'));

const LiveJobs = lazy(() => import('../../container/jobs/LiveJobs'));
const AddEditJob = lazy(() => import('../../container/jobs/AddEditJob'));
const AlarmedJobs = lazy(() => import('../../container/jobs/Alarms'));
const OrdersConfirmed = lazy(() => import('../../container/jobs/OrdersConfirmed'));
const CompletedJobs = lazy(() => import('../../container/jobs/CompletedJobs'));
const JobHistory = lazy(() => import('../../container/jobs/JobHistory'));
const JobsCompleted = lazy(() => import('../../container/jobs/JobsCompleted'));
const InvoiceSent = lazy(() => import('../../container/jobs/InvoiceSent'));
const VDRCOC = lazy(() => import('../../container/jobs/VDRCOC'));

const JobPublishers = lazy(() => import('../../container/jobPublishers'));
const AddEditPublisher = lazy(() => import('../../container/jobPublishers/AddEditPublisher'));

const Admins = lazy(() => import('../../container/admins'));

const Companies = lazy(() => import('../../container/companies'));
const Engineers = lazy(() => import('../../container/engineers'));
const Agents = lazy(() => import('../../container/agents'));
const JobDescriptions = lazy(() => import('../../container/jobDescriptions'));
const Spares = lazy(() => import('../../container/spares'));
const Accountants = lazy(() => import('../../container/accountants'));
const Countries = lazy(() => import('../../container/countries'));

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  const roleId = useSelector((store) => store.auth.loginData?.role_id ?? 0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin flex items-center justify-center bg-white dark:bg-dark h-screen w-full fixed z-[999] ltr:left-0 rtl:right-0 top-0">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route
          path="/"
          element={<Navigate to={[1, 2].includes(roleId) ? AppRoutes.dashboard : roleId ===6 ? AppRoutes.spareVerified : AppRoutes.orderConfirmedJobs} />}
        />
        {[5, 1, 2].includes(roleId) && <Route path={AppRoutes.dashboard} element={<Dashboard />} />}
        {[5, 1, 2, 3, 4, 6].includes(roleId) && <Route path={AppRoutes.addEditJob} element={<AddEditJob />} />}
        {[5, 1, 2].includes(roleId) && <Route path={`${AppRoutes.liveJobs}/*`} element={<LiveJobs />} />}
        {[5, 1, 2].includes(roleId) && <Route path={AppRoutes.alarmedJobs} element={<AlarmedJobs />} />}
        {[5, 1, 2].includes(roleId) && <Route path={AppRoutes.cancelledJobs} element={<CancelledJobs />} />}
        {[5, 1, 2].includes(roleId) && <Route path={AppRoutes.vdrCOC} element={<VDRCOC />} />}
        {[5, 1, 2, 3, 4].includes(roleId) && (
          <Route path={AppRoutes.orderConfirmedJobs} element={<OrdersConfirmed />} />
        )}
        {[5, 1, 6].includes(roleId) && <Route path={AppRoutes.sparePrepare} element={<SpareJobs isPrepared />} />}
        {[5, 1, 6].includes(roleId) && <Route path={AppRoutes.spareVerified} element={<SpareJobs />} />}
        {[5, 1, 6].includes(roleId) && <Route path={AppRoutes.logisticJobs} element={<LogisticsJob />} />}
        {[5, 1, 2, 3, 4].includes(roleId) && <Route path={AppRoutes.jobCompleted} element={<JobsCompleted />} />}
        {[5, 1, 2, 4].includes(roleId) && <Route path={AppRoutes.invoiceSent} element={<InvoiceSent />} />}
        {[5, 1, 2].includes(roleId) && <Route path={AppRoutes.completedJobs} element={<CompletedJobs />} />}
        {[5, 1, 2].includes(roleId) && <Route path={AppRoutes.jobHistory} element={<JobHistory />} />}
        {[5, 1].includes(roleId) && <Route path={`${AppRoutes.jobPublishers}/*`} element={<JobPublishers />} />}
        {[5].includes(roleId) && <Route path={`${AppRoutes.admins}/*`} element={<Admins />} />}
        {[5, 1].includes(roleId) && <Route path={`${AppRoutes.addJobPublisher}/*`} element={<AddEditPublisher />} />}
        {[5, 1].includes(roleId) && <Route path={`${AppRoutes.accountant}`} element={<Accountants />} />}
        {[5, 1].includes(roleId) && <Route path={`${AppRoutes.logistics}`} element={<Logistics />} />}
        {[5, 1].includes(roleId) && <Route path={AppRoutes.companies} element={<Companies />} />}
        {[5, 1].includes(roleId) && <Route path={AppRoutes.engineers} element={<Engineers />} />}
        {[5, 1].includes(roleId) && <Route path={AppRoutes.jobDescriptions} element={<JobDescriptions />} />}
        {[5, 1].includes(roleId) && <Route path={AppRoutes.country} element={<Countries />} />}
        {[5, 1].includes(roleId) && <Route path={AppRoutes.spares} element={<Spares />} />}
        {[5, 1].includes(roleId) && <Route path={AppRoutes.agents} element={<Agents />} />}
        <Route path={AppRoutes.onboard} element={<OnBoard />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
